module.exports = __webpack_public_path__ + "static/media/estrutura1.fb2042dd.jpg";